<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="responsive">
  <BackgroundImage />

    <!-- 住所の重複 -->
    <transition name="popup">
      <TrialRegistrationPostnumberDuplicated
        v-if="group1.visiblePostnumberDuplicated"
        @closeButtonClicked="group1.visiblePostnumberDuplicated = false"
        @submitButtonClicked="group1.onTrialRegistrationPostnumberDuplicatedSubmitted($event)"
        :list="group1.duplicatedAddressList"
      />
    </transition>

    <div id="wrapper">
      <div id="head-logo">
        <router-link to="/pc/login" target="_blank">
          <img src="/lc/app/images/log-1row.svg" alt="LEGAL CONNECTION">
        </router-link>
      </div>
      <!-- content:start -->
      <div id="content">
        <div class="contact">
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link">無料トライアルの申し込み</span>
              <span class="breadcrumb-link current">無料トライアルの登録</span>
              <span class="breadcrumb-link">無料トライアルの登録の確認</span>
              <span class="breadcrumb-link">無料トライアルの登録の完了</span>
            </div>
            <h1 class="hdg02">無料トライアルの登録</h1>
            <a href="/lc/about/" target="_blank" class="contact-head-link">LEGAL CONNECTIONについて <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
          </div>
          <form @submit.prevent class="contact-container">
            <div class="contact-content">

              <p class="txt" :class="group1.isError ? 'mb20' : 'mb40'">以下に必要事項を入力して無料トライアルのお申し込みを完了してください。</p>
              <p class="error-message side-margin mb40" v-if="group1.isError">入力内容に不備があるようです。下記メッセージ（赤文字）のご確認をお願いいたします。</p>

              <h2 class="hdg03">無料トライアルの登録フォーム</h2>
              <ul class="contact-content-list">
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          法人名/個人名 <span class="txt-red">[必須]</span>
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.name" placeholder="新日本法規出版株式会社">
                          </div>
                          <p class="txt-sup">
                            法人形態は省略せず入力をお願いします。個人の場合は個人のお名前を入力してください。
                          </p>
                          <p class="error-message" v-if="group1.error_name">{{group1.error_name}}</p>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          読み仮名 <span class="txt-red">[必須]</span>
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.kana" placeholder="シンニッポンホウキシュッパンカブシキガイシャ">
                          </div>
                          <p class="error-message" v-if="group1.error_kana">{{group1.error_kana}}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          ご担当者名 <span class="txt-red">[必須]</span>
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.charge_name" placeholder="山田太郎">
                          </div>
                          <p class="txt-sup">
                            個人名とご担当者様が同じ場合も、ご入力ください。<br>ご請求書には記載されません。
                          </p>
                          <p class="error-message" v-if="group1.error_charge_name">{{group1.error_charge_name}}</p>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          ご担当部署名
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.department" placeholder="法務部">
                          </div>
                          <p class="txt-sup">
                            ご連絡先となりますので、団体・法人の場合は必要に応じて部署名まで入力してください。
                          </p>
                          <p class="error-message" v-if="group1.error_department">{{group1.error_department}}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          住所 <span class="txt-red">[必須]</span>
                        </th>
                        <td>
                          <p class="txt-sup mb24">
                            郵便番号から住所検索を実行してください。システムの都合上、半角文字はすべて全角に変換されます。お手元に請求書若しくは納品書がある場合は、記載されているとおりに住所をご入力ください。<br>
                            （例）「３－１－８」と記載されている場合は、正式な表記が「３丁目１番８号」だとしても、「３－１－８」とご入力ください。
                          </p>
                          <p class="txt mb12">郵便番号 <span class="txt-red">[必須]</span></p>
                          <div class="column gutter align-center mb8">
                            <div class="column-item space-gutter" :class="group1.device === 'sp' ? 'col-4' : 'col-3'">
                              <div class="formparts text">
                                <input type="text" v-model="group1.postnumber" placeholder="4608455" maxlength="7">
                              </div>
                            </div>
                            <div class="column-item col-3 space-gutter">
                              <div class="button" 
                                @click="group1.fetchAddresses(group1.postnumber)"
                              >
                                <button class="btn" type="button" name="button">住所検索</button>
                              </div>
                            </div>
                            <div class="column-item col-3 space-gutter">
                              <span class="txt-sup">例:4608455</span>
                            </div>
                          </div>
                          <p class="error-message" v-if="group1.error_postnumber">{{group1.error_postnumber}}</p>
                          <template
                            v-if="group1.visibleAddress"
                          >
                            <p class="txt">市区郡 <span class="txt-red">[必須]</span></p>
                            <div class="formparts text formparts-short">
                              <input type="text" v-model="group1.address" placeholder="名古屋市中区">
                              <p class="error-message" v-if="group1.error_address">{{group1.error_address}}</p>
                            </div>
                            <p class="txt">町村域大字 <span class="txt-red">[必須]</span></p>
                            <div class="formparts text formparts-short">
                              <input type="text" v-model="group1.address2" placeholder="栄">
                              <p class="error-message" v-if="group1.error_address2">{{group1.error_address2}}</p>
                            </div>
                            <p class="txt">小字以下番地 <span class="txt-red">[必須]</span></p>
                            <div class="formparts text formparts-short">
                              <input type="text" v-model="group1.address3" placeholder="１－２３－２０">
                              <p class="error-message" v-if="group1.error_address3">{{group1.error_address3}}</p>
                            </div>
                            <p class="txt">マンション・ビル名等</p>
                            <div class="formparts text formparts-short">
                              <input type="text" v-model="group1.address4" placeholder="新日本ビル３Ｆ">
                              <p class="error-message" v-if="group1.error_address4">{{group1.error_address4}}</p>
                            </div>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          メールアドレス <span class="txt-red">[必須]</span>
                        </th>
                        <td>
                          <div class="formparts text formparts-short is-inactive">
                            <input readonly type="email" v-model="group1.email">
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          職業 <span class="txt-red">[必須]</span>
                        </th>
                        <td>
                          <div class="formparts select formparts-short"
                            @mouseenter="group1.displayOccupationClassificationSelect = true"
                            @mouseleave="group1.displayOccupationClassificationSelect = false"
                            :class="{ 'is-visible-list': group1.displayOccupationClassificationSelect }"
                          >
                            <div class="select-label" role="select">{{ group1.selectedOccupationClassificationName || '業種を選んでください' }}<FontawesomeIcon icon="angle-down" class="icn" /></div>
                            <!-- <div class="select-label" role="select">ライセンス数を選択※アクティブ<FontawesomeIcon icon="angle-up" class="icn" /></div> -->
                            <div class="select-option">
                              <ul class="select-option-list">
                                <li v-for="item in group1.occupationClassificationList" :key="'occupation_classification_' + item.id" role="option">
                                  <label><input type="radio"
                                    v-model="group1.occupation_classification" :value="item.id"
                                    @click="group1.onOccupationClassificationListSelected()">{{ item.name }}</label>
                                </li>
                              </ul>
                            </div>
                            <p class="error-message" v-if="group1.error_occupation_classification">{{group1.error_occupation_classification}}</p>
                          </div>
                          <div class="formparts select formparts-short"
                            @mouseenter="group1.displayOccupationSelect = true"
                            @mouseleave="group1.displayOccupationSelect = false"
                            :class="{ 'is-visible-list': group1.displayOccupationSelect }"
                          >
                            <div class="select-label" role="select">{{ group1.selectedOccupationName || '職業を選んでください' }}<FontawesomeIcon icon="angle-down" class="icn" /></div>
                            <!-- <div class="select-label" role="select">ライセンス数を選択※アクティブ<FontawesomeIcon icon="angle-up" class="icn" /></div> -->
                            <div class="select-option">
                              <ul class="select-option-list">
                                <li v-for="item in group1.occupationList" :key="'occupation_' + item.id" role="option">
                                  <label><input type="radio"
                                    v-model="group1.occupation" :value="item.id"
                                    @click="group1.onOccupationListSelected()">{{ item.name }}</label>
                                </li>
                              </ul>
                            </div>
                            <p class="error-message" v-if="group1.error_occupation">{{group1.error_occupation}}</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          電話番号1 <span class="txt-red">[必須]</span>
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.tel" placeholder="052-211-5788" maxlength="13">
                            <p class="error-message" v-if="group1.error_tel">{{group1.error_tel}}</p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          電話番号2
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.tel2" placeholder="090-000-0000" maxlength="13">
                          </div>
                          <p class="txt-sup">日中にご連絡がつきやすい電話番号をご入力ください。（携帯電話等）</p>
                          <p class="error-message" v-if="group1.error_tel2">{{group1.error_tel2}}</p>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          内線番号
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.extension" placeholder="1301" maxlength="5">
                            <p class="error-message" v-if="group1.error_extension">{{group1.error_extension}}</p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          FAX番号
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.fax" placeholder="052-211-5796" maxlength="13">
                            <p class="error-message" v-if="group1.error_fax">{{group1.error_fax}}</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          弊社社員からの紹介であれば社員名を入力してください
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.introducer" placeholder="山田太郎">
                          </div>
                          <p class="txt-sup">
                            不明の場合は入力不要です。
                          </p>
                          <p class="error-message" v-if="group1.error_introducer">{{group1.error_introducer}}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          備考
                        </th>
                        <td>
                          <div class="formparts textarea">
                            <textarea v-model="group1.note" rows="5" placeholder="ご質問などがありましたら、ご入力ください。"></textarea>
                            <p class="error-message" v-if="group1.error_note">{{group1.error_note}}</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>

              <h2 class="hdg03">無料トライアルを希望するパッケージ</h2>
              <ul class="contact-content-list">
                <li class="contact-content-list-item contact-content-list-item-noline">
                  <p class="error-message side-margin" v-if="group1.error_productsLicenses">{{group1.error_productsLicenses}}</p>
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <td>
                          <div class="tbl05-wrapper">
                            <ul class="contact-content-table-list">
                              <li v-for="(item, index) in group1.packagesAndProducts" :key="'product_' + index">
                                <div class="formparts checkbox">
                                  <input type="checkbox" :id="'product_'+item.product_id" :value="item.product_id"
                                   v-model="group1.selectedProductIds" @click="group1.error_productsLicenses=''">
                                  <label :for="'product_'+item.product_id" role="button">{{ item.product_name }}<FontawesomeIcon icon="check" class="icn" /></label>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>
              
              <h2 class="hdg04">個人情報の取り扱いについて</h2>
              <p class="txt">お客様の個人情報は、本人確認、お問い合わせ対応および各種ご案内の送付などの業務活動並びに当社の定める利用目的の範囲内で、当社の関連会社や協力会社に対して提供する場合があります。<br>
本ページ記載事項（規約を含む）を必ずご確認いただきますようお願いいたします。本ページ記載事項（規約を含む）にご同意いただいた場合は、[同意した上で進む]ボタンをクリックして確認画面へお進みください。</p>
              <ul class="list-inline mt12">
                <li>
                  <a href="https://www.sn-hoki.co.jp/guide/social_rules/" class="txt-blue" target="_blank">利用規約 <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
                </li>
                <li>
                  <a href="https://www.sn-hoki.co.jp/privacy/" class="txt-blue" target="_blank">プライバシーポリシー <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
                </li>
              </ul>


              <div class="contact-submit">
                <!-- <div class="button contact-submit-button">
                  <button class="btn" type="submit" name="button">確認</button>
                </div> -->
                <!-- 挙動確認用 -->
                <div class="button contact-submit-button">
                  <button class="btn" @click="group1.submitButtonClicked">同意した上で進む</button>
                </div>
              </div>


            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
// import '@/components/style/RESCommonCSS.vue'
import store from '@/store'
import TrialRegistrationPostnumberDuplicated from '@/components/public/trial-registration/popup/TrialRegistrationPostnumberDuplicated.vue'
import * as logicTrialRegistration from '@/logic/public/TrialRegistration'
import * as common from '@/util/common'

export default defineComponent({
  components: {
    TrialRegistrationPostnumberDuplicated
  },
  beforeRouteEnter (to, from, next) {
    if (from.name !== 'TrialRegistrationConfirm') {
      // 確認画面以外から遷移して来た場合はストアに保持している値を全クリア
      store.dispatch('inquiry/clearAllStates')
    }
    next()
  },
  setup (props, context) {

    onMounted(() => {
      group1.init()
    })

    const group1 = logicTrialRegistration.getGroupIndex()

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
.contact-content {
  &-note{
    margin-top: 12px;
    font-size: 1.4rem;
    color: #999;
    list-style: none;
  }
}
.contact-content-list-item.contact-content-list-item-noline:last-child {
  border-bottom: none;
}
@media screen and (min-width:$width-container + 1) {
  .formparts-short{
    width: 60%;
  }
}
</style>
